// extracted by mini-css-extract-plugin
export default {"input":"TemplateForm_input__+j+DU","title":"TemplateForm_title__SiF3i","text":"TemplateForm_text__XLvLd","btn":"TemplateForm_btn__ekUCf","btns":"TemplateForm_btns__XXeLM"};